import { get } from "../utils";
import { InterviewVideoUrlParams } from "./type";

export async function getInterviewVideoUrl(queryParams?: InterviewVideoUrlParams): Promise<string> {
  return (await get({ path: "outdefine_hire/interview_video_section/stream-url", queryParams }))
    .body.url;
}

export async function downloadVideo(queryParams?: InterviewVideoUrlParams) {
  const resp = await get({
    path: "outdefine_hire/interview_video_section/download",
    queryParams
  });
  const url = resp.body.url;
  if (!url) throw new Error("Error generating download url for interview section");

  const link = document.createElement("a");
  link.href = url;
  link.click();
}
